import {MantineProvider} from "@mantine/core";
import {Notifications} from "@mantine/notifications";
import {Outlet} from "@tanstack/react-router";
import {AnankeTempTanstackRouterLinkComponent} from "~/components/anankeTemp/anankeTempTanstackRouterLinkComponent";
import {IntellsysConfigurationContext} from "~/contexts/intellsysConfigurationContext";
import {AnankeAppProvider} from "@vesta/ananke/components/anankeAppProvider";
import {AnankeFlagProvider} from "@vesta/ananke/components/anankeFlagProvider";
import {useAnankePreferences} from "@vesta/ananke/contexts/anankeClientContext";
import {Route} from "./__root";

export function RouteComponent() {
    const {
        intellsysBaseUrl,
    } = Route.useRouteContext();
    const {theme} = useAnankePreferences();

    return (
        <IntellsysConfigurationContext.Provider
            value={{
                // hadesBaseUrl: hadesBaseUrl,
                intellsysBaseUrl: intellsysBaseUrl,
            }}
        >
            <AnankeAppProvider
                routerLinkComponent={AnankeTempTanstackRouterLinkComponent}
                UNSAFE_isThemingDisabled={true}
            >
                <AnankeFlagProvider>
                    <MantineProvider forceColorScheme={theme}>
                        <Notifications
                            position="bottom-left"
                            autoClose={5000}
                            zIndex={1000}
                        />
                        <div data-ag-theme-mode={theme}>
                            <Outlet />
                        </div>
                    </MantineProvider>
                </AnankeFlagProvider>
            </AnankeAppProvider>
        </IntellsysConfigurationContext.Provider>
    );
}
